import ScrollMagic from "scrollmagic";

export function sminit() {
    let controller = new ScrollMagic.Controller();
    class ScrollFade {
        constructor() {
            this.ANIMATION_CLASS = "is-fire";
            this.ANIMATION_END_CLASS = "is-end";

            let $section = document.querySelectorAll(
                ".Js-scroll:not(.is-fire)"
            );
            if ($section.length === null) {
                return;
            }
            // let controller = new ScrollMagic.Controller();
            for (let i = 0; i < $section.length; i++) {
                let scene = new ScrollMagic.Scene({
                    triggerElement: $section[i],
                    triggerHook: "onEnter",
                    reverse: false,
                    offset: 150,
                }).addTo(controller);
                scene.on("enter", () => {
                    $section[i].classList.add(this.ANIMATION_CLASS);
                    setTimeout(() => {
                        $section[i].classList.add(this.ANIMATION_END_CLASS);
                    }, 1000);
                });
                scene.on("end", () => {
                    scene.destroy(true);
                });
            }
        }
    }

    new ScrollFade();
}

sminit();
